export default __webpack_public_path__ + "static/LMhover-194cd9cf6de35a5a033ab4e674920c2a.png";